function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExhibition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8711 35.4841H19.6776C20.1617 35.4841 20.6089 35.2258 20.8509 34.8067C21.0931 34.3876 21.0931 33.871 20.8509 33.4519C20.609 33.0327 20.1618 32.7744 19.6776 32.7744H17.8711C17.0328 32.7744 16.2286 32.4413 15.6357 31.8486C15.0429 31.2557 14.7098 30.4515 14.7098 29.6131V17.8711C14.7098 17.0327 15.0429 16.2285 15.6357 15.6356C16.2286 15.0429 17.0328 14.7097 17.8711 14.7097H32.7746C33.613 14.7097 34.4172 15.0429 35.0101 15.6356C35.6028 16.2285 35.936 17.0327 35.936 17.8711V18.3227C35.936 18.8068 36.1943 19.254 36.6134 19.496C37.0326 19.7381 37.5491 19.7381 37.9683 19.496C38.3874 19.254 38.6457 18.8068 38.6457 18.3227V17.8711C38.6457 16.3139 38.0271 14.8206 36.9261 13.7196C35.8252 12.6186 34.3318 12 32.7746 12H17.8711C16.314 12 14.8206 12.6186 13.7196 13.7196C12.6186 14.8205 12 16.3139 12 17.8711V29.6131C12 31.1703 12.6186 32.6636 13.7196 33.7646C14.8205 34.8656 16.3139 35.4842 17.8711 35.4842L17.8711 35.4841Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0005 38.6452V38.4194C40.0017 37.0825 39.6623 35.7673 39.0144 34.5979C38.3663 33.4285 37.4314 32.4434 36.2973 31.7354L35.8819 31.4734L36.18 31.0805L36.1799 31.0806C36.9017 30.1418 37.2923 28.9906 37.2908 27.8064C37.2919 26.0409 36.4327 24.3856 34.9885 23.37C33.5442 22.3544 31.696 22.1063 30.0349 22.7045C28.374 23.3027 27.1084 24.6725 26.6434 26.3756C26.1784 28.0787 26.5719 29.9017 27.6985 31.261L28.0146 31.6403L27.6081 31.9203C26.5564 32.6471 25.6963 33.618 25.1016 34.7499C24.5071 35.8815 24.1956 37.1405 24.1938 38.4191V38.6449C24.1938 39.129 24.4521 39.5762 24.8713 39.8182C25.2904 40.0603 25.807 40.0603 26.2261 39.8182C26.6453 39.5762 26.9036 39.129 26.9036 38.6449V38.4191C26.9036 36.5637 27.8934 34.8491 29.5004 33.9214C31.1074 32.9936 33.0871 32.9936 34.694 33.9214C36.301 34.8491 37.2909 36.5637 37.2909 38.4191V38.6449C37.2909 39.129 37.5492 39.5762 37.9683 39.8182C38.3874 40.0603 38.904 40.0603 39.3231 39.8182C39.7423 39.5762 40.0006 39.129 40.0006 38.6449L40.0005 38.6452ZM31.8714 30.5161C31.1527 30.5161 30.4634 30.2306 29.9553 29.7224C29.4471 29.2143 29.1616 28.525 29.1616 27.8064C29.1616 27.0878 29.4471 26.3985 29.9553 25.8904C30.4634 25.3822 31.1527 25.0967 31.8714 25.0967C32.59 25.0967 33.2793 25.3822 33.7874 25.8904C34.2956 26.3985 34.5811 27.0878 34.5811 27.8064C34.5811 28.525 34.2956 29.2143 33.7874 29.7224C33.2793 30.2306 32.59 30.5161 31.8714 30.5161Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibition);
export default __webpack_public_path__ + "static/media/exhibition.8474ec0e4342ec0a62fac85ed569f733.svg";
export { ForwardRef as ReactComponent };